/** Logo + "Multiva" del header · chip naranja de marca con el vector blanco
 *  dentro (sobre header blanco) + texto en color de texto principal. */
export function MultivaBrand() {
  return (
    <div className="flex items-center gap-2">
      <div className="flex size-8 items-center justify-center rounded-lg bg-gradient-to-br from-multiva-500 to-multiva-700 shadow-sm">
        <svg viewBox="0 0 120 120" width="18" height="18" role="img" aria-label="Multiva">
          <path
            d="M 8 110 V 74 A 32 32 0 0 1 48 43.02 V 42 A 32 32 0 0 1 112 42 V 110 H 88 V 42 A 8 8 0 0 0 72 42 V 110 H 48 V 74 A 8 8 0 0 0 32 74 V 110 Z"
            fill="#ffffff"
          />
        </svg>
      </div>
      <span className="hidden text-sm font-semibold text-foreground sm:inline">Portal de Proveedores Multiva</span>
    </div>
  );
}
